"use client";
import { motion } from "framer-motion";
import { ContainerGlob } from "../../../componentsGLob/ContainerGlob";
import { staticServicesData } from "./servicesData";
import { ServiceCard } from "./ServiceCard";
import { useTranslation } from "react-i18next";
import { ServiceProps } from "./interfaces";

const ServicesGrid = () => {
  const { t } = useTranslation("services");

  const translatedServices: ServiceProps[] = staticServicesData.map(
    (staticItem) => ({
      title: t(`items.${staticItem.key}.title`),
      description: t(`items.${staticItem.key}.description`),
      icon: staticItem.icon,
      bgClass: staticItem.bgClass,
      color: staticItem.color,
    })
  );

  return (
    <section className="w-full py-12 md:py-16 bg-white" id="services">
      <ContainerGlob>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="text-center mb-10 md:mb-12"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
            {t("mainTitlePart1")}{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-green-500">
              {t("mainTitlePart2")}
            </span>
          </h2>
          <h3 className="mt-4 text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            {t("subtitle")}
          </h3>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-5 lg:gap-6"
        >
          {translatedServices.map((service, index) => (
            <ServiceCard key={index} service={service} />
          ))}
        </motion.div>
      </ContainerGlob>
    </section>
  );
};

export default ServicesGrid;
